import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { toTitle } from '../../../common/utils/formatString'
import SearchLink from '../../containers/searchLinkContainer'
import FilterPanel from './filterExpandPanel/panelContainer'
import FilterGroupPanel from './filterGroup/groupPanelContainer'

import * as styles from './searchFilters.module.css'

interface IProps {
  locationParams: ILocationParams
  activeFilters: any[]
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  toggleSidebar: () => void
  totalHits: number
  loading: boolean
}

const MobileFiltersHeader = ({
  toggleSidebar,
  totalHits,
  locationParams
}: {
  toggleSidebar: () => void
  totalHits: number
  locationParams: ILocationParams
}) => {
  const clearAllLinkParams = locationParams.term
    ? { term: locationParams.term }
    : { term: '' }

  const closeFiltersPanel = () => {
    document.body.classList.remove('mobileScrollLock')
    toggleSidebar()
  }

  return (
    <div className={styles.mobileFiltersHeaderWrapper}>
      <div className={styles.mobileFiltersLabels}>
        <h3 className={styles.mobileFiltersHeader}>Filter & Refine</h3>
        <span className={styles.mobileFiltersCount}>
          {totalHits} {totalHits === 1 ? 'result' : 'results'}
        </span>
      </div>
      <SearchLink
        locationParams={clearAllLinkParams}
        className={styles.mobileFiltersClearLink}
      >
        Clear all
      </SearchLink>
      <button
        className={styles.mobileFiltersActionButton}
        onClick={closeFiltersPanel}
      >
        Done
      </button>
    </div>
  )
}

const SearchFilters = ({
  locationParams,
  activeFilters = [],
  currentSite,
  makeSearchLink,
  toggleSidebar,
  totalHits,
  loading
}: IProps) => {
  const currentCategory = locationParams.category

  return (
    <div data-test-selector="search-filters">
      <FilterGroupPanel id="filterGroup">
        <MobileFiltersHeader
          toggleSidebar={toggleSidebar}
          totalHits={totalHits}
          locationParams={locationParams}
        />

        {activeFilters.map((filter, index, list) => {
          const filterOptionsCount = get(filter, 'props.items.length', 0)
          const alwaysShowAllOnMobile = filter.id === 'category'
          return (
            <FilterPanel
              title={filter.title || toTitle(filter.id)}
              id={filter.id}
              key={filter.id}
              expanded={filter.expanded}
              locationParams={locationParams}
              filterOptionsCount={filterOptionsCount}
              hasShowMoreOnMobile={!alwaysShowAllOnMobile}
              loading={loading}
            >
              <filter.Component
                key={index}
                locationParams={locationParams}
                makeSearchLink={makeSearchLink}
                {...filter.props}
              />
            </FilterPanel>
          )
        })}
      </FilterGroupPanel>
    </div>
  )
}

export default SearchFilters
